<template>
  <div :class="['rb-diamond-explorer', { 'rb-active': active }]">
    <div class="rb-explorer-header">
      <button aria-label="Close" @click.prevent="closeDiamondExplorer">
        <icon-close />
      </button>
    </div>
    <div class="rb-explorer-content">
      <div class="rb-grad"></div>
      <div class="rb-content">
        <step
          :key="`step-diamond-explorer`"
          :data="data"
          :active="true"
          :selected-options="selectedOptions"
          :diamonds-data="diamondsData"
          :diamonds-meta="diamondsMeta"
          :selectors="false"
          :api="config.api"
          :enable-v360="config.enableV360"
        ></step>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Diamond Explorer Window
 *
 * @summary
 * Displays an overlay with different options for diamonds listing (grid / table). Filter options. Search.
 *
 * @props
 * config: Object
 *
 * @implements
 * ChildMixin
 * DiamondsMixin
 * CommMixin
 *
 * @listens
 * rb-open-diamond-explorer
 * rb-close-diamond-explorer
 */
import CommMixin from "@/mixins/CommMixin";
import ChildMixin from "@/mixins/ChildMixin";
import DiamondsMixin from "@/mixins/DiamondsMixin";
import IconClose from "@/components/icons/IconClose";
import Step from "@/components/Step";
export default {
  mixins: [ChildMixin, DiamondsMixin, CommMixin],
  components: { Step, IconClose },
  props: {
    config: {
      type: Object,
    },
  },
  data: function () {
    return {
      active: false,
    };
  },
  mounted: function () {
    this.subscribe("rb-open-diamond-explorer", this.onOpenDiamondExplorer);
    this.subscribe("rb-close-diamond-explorer", this.onCloseDiamondExplorer);
  },
  methods: {
    onOpenDiamondExplorer: function () {
      this.openDiamondExplorer();
    },
    onCloseDiamondExplorer: function () {
      this.closeDiamondExplorer();
    },
    openDiamondExplorer: function () {
      this.active = true;
    },
    closeDiamondExplorer: function () {
      this.active = false;
    },
  },
};
</script>
